import { Component, OnInit, Inject } from "@angular/core";
import { QualityProjectService } from "./../service/quality-project.service";
import {  MatDialogRef,  MAT_DIALOG_DATA } from "@angular/material/dialog";
import { tap } from "rxjs/operators";

export interface DialogData {
  id: string;
  name: string;
}
@Component({
  selector: "app-dialog",
  templateUrl: "./dialog.component.html",
  styleUrls: ["./dialog.component.css"],
})
export class DialogComponent implements OnInit {
  projectId: string;
  constructor(
    private qaService: QualityProjectService,
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit() {}

  complete(taskId: string): void {
    this.qaService
      .complete(taskId)
      .pipe(tap(() => this.dialogRef.close(this.data.id)))
      .subscribe();
  }

  onCloseCancel() {
    this.dialogRef.close();
  }
}
